module.exports = __webpack_public_path__ + "static/media/image_3.2bf35e04.jpg";